import React, { useEffect, useState } from 'react';
import FeatherIcon from 'feather-icons-react';
import { Spin, Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
//
import { getRequestedCars, reRequestCar } from '../../../redux/carImport/carAmigo/actionCreator';
import { Button } from '../../../components/buttons/buttons';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { UserTableStyleWrapper } from '../../pages/style';
import { TableWrapper } from '../../styled';

const RequestedCarColumns = [
  {
    title: 'Sn',
    dataIndex: 'index',
    key: 'index',
  },
  {
    title: 'Brand',
    dataIndex: 'brand',
    key: 'brand',
  },
  {
    title: 'Model',
    dataIndex: 'model',
    key: 'model',
  },
  {
    title: 'Fuel Type',
    dataIndex: 'fuel',
    key: 'fuel',
  },
  {
    title: 'Gearbox',
    dataIndex: 'gearbox',
    key: 'gearbox',
  },
  {
    title: 'Year',
    dataIndex: 'year',
    key: 'year',
  },
  {
    title: 'Number Asked',
    dataIndex: 'numberAsked',
    key: 'numberAsked',
  },
  {
    title: 'Power From',
    dataIndex: 'powerfrom',
    key: 'powerfrom',
  },
  {
    title: 'Power To',
    dataIndex: 'powerto',
    key: 'powerto',
  },
  {
    title: 'Power Type',
    dataIndex: 'powertype',
    key: 'powertype',
  },
  {
    title: 'KM From',
    dataIndex: 'kmfrom',
    key: 'kmfrom',
  },
  {
    title: 'KM To',
    dataIndex: 'kmto',
    key: 'kmto',
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
    width: 50,
    fixed: 'right',
  },
];

const CarAmigoRequestedCarList = () => {
  const dispatch = useDispatch();
  const [queryState, setQueryState] = useState({ page: 1, limit: 10 });
  const { requestedCars, apiLoading, requestedCarsTotal, reRequestingId } = useSelector(reduxState => ({
    apiLoading: reduxState.carAmigo.apiLoading,
    requestedCars: reduxState.carAmigo.requestedCars,
    requestedCarsPage: reduxState.carAmigo.requestedCarsPage,
    requestedCarsLimit: reduxState.carAmigo.requestedCarsLimit,
    requestedCarsTotal: reduxState.carAmigo.requestedCarsTotal,
    reRequestingId: reduxState.carAmigo.reRequestingId,
  }));

  const handleReRequest = async requestId => {
    const res = await dispatch(reRequestCar(requestId));
    if (res.status === 200) {
      dispatch(getRequestedCars(`page=${queryState.page}&limit=${queryState.limit}`));
    }
  };

  const requestedCarTypes = [];

  requestedCars.map((car, index) => {
    const { _id, brand, model, fuel, gearbox, year, numberAsked, powerFrom, powerTo, powerType, kmFrom, kmTo } = car;
    return requestedCarTypes.push({
      key: _id,
      index: index + 1,
      year: year || '-',
      brand: brand ? <span className="text-capitalize">{brand}</span> : '-',
      model: model ? <span className="text-capitalize">{model}</span> : '-',
      fuel: fuel ? <span className="text-capitalize">{fuel}</span> : '-',
      gearbox: gearbox ? <span className="text-capitalize">{gearbox}</span> : '-',
      numberAsked: numberAsked || '-',
      powerfrom: powerFrom || '-',
      powerto: powerTo || '-',
      powertype: powerType || '-',
      kmfrom: kmFrom || '-',
      kmto: kmTo || '-',
      actions: (
        <div className="table-actions">
          <>
            <Button
              className="btn-icon"
              type="info"
              to="#"
              shape="circle"
              onClick={() => handleReRequest(_id)}
              disabled={reRequestingId}
              title="Re-Request"
            >
              {reRequestingId === _id ? <Spin /> : <FeatherIcon icon="rotate-ccw" size={16} />}
            </Button>
          </>
        </div>
      ),
    });
  });

  useEffect(() => {
    dispatch(getRequestedCars(`page=${queryState.page}&limit=${queryState.limit}`));
  }, [queryState.page, queryState.limit]);

  return (
    <Cards headless>
      {apiLoading ? (
        <div className="spin">
          <Spin />
        </div>
      ) : (
        <UserTableStyleWrapper>
          <TableWrapper className="table-responsive">
            <Table
              dataSource={requestedCarTypes}
              columns={RequestedCarColumns}
              pagination={{
                current: queryState.page,
                defaultPageSize: queryState.limit,
                total: requestedCarsTotal,
                showSizeChanger: true,
              }}
              onChange={data => setQueryState(prev => ({ ...prev, page: data.current, limit: data.pageSize }))}
            />
          </TableWrapper>
        </UserTableStyleWrapper>
      )}
    </Cards>
  );
};

export default CarAmigoRequestedCarList;
